import React, { useEffect, useState } from "react";
import { useMemo } from "react";
import styles from "./styles/Users.module.css";
import TableFilter from "./TableFilter";
import { UsersTable } from "./UsersTable";
import TableFooter from "./TableFooter";
import { NewUser } from "./NewUser";
import { useAlert } from "../../../Context/AlertContext";
import config from "../../../config";
import { formatDate } from "../../../Utils/formatDate";

const base_url = config.base_url;
function Users() {
  const alert = useAlert();
  const [data, setData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [filter, setFilter] = useState({
    filter_value: "",
    filter_field: "user_id",
    max_date: Date.now(),
    min_date: Date.now() - 1000 * 60 * 60 * 24 * 7,
    sort: "",
    nlogs: "20",
    page: 1,
  });
  const [maxPages, setmaxPages] = useState(1);
  const RequestData = (filter) => {
    console.log(filter);
    fetch(base_url + "admin/users", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      body: `filter_value=${filter.filter_value}&filter_field=${filter.filter_field}&max_date=${filter.max_date}&min_date=${filter.min_date}&nlogs=${filter.nlogs}&page=${filter.page}&sort=${filter.sort}`,
      credentials: "include",
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        console.log(data);
        if (data?.error) alert("");
        else {
          if (data.result.total === 0) setmaxPages(1);
          else setmaxPages(Math.ceil(data.result.total / filter.nlogs));
          setData(data.result.data);
        }
      });
  };
  const DownloadCSV = (filter) => {
    fetch(base_url + "users/download", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      body: `filter_value=${filter.filter_value}&max_date=${filter.max_date}&min_date=${filter.min_date}`,
      credentials: "include",
    })
      .then((res) => {
        if (res.status !== 200) throw new Error("Response status is not 200");
        res.blob();
      })
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "EventLogs.csv");
        document.body.appendChild(link);
        link.click();
      })
      .catch((e) => {
        return;
      });
  };
  const DeleteUser = (user_id) => {
    fetch(base_url + "admin/users/remove", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      body: `user_id=${user_id}&user_id=${user_id}`,
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.error) alert.push("Error", data.error);
        else {
          console.log(data);
          alert.push("Removed", data.result);
          setRefresh(!refresh);
        }
      });
  };
  const DisableUser = (user_id) => {
    fetch(base_url + "admin/users/disable", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      body: `employee_id=${user_id}`,
      credentials: "include",
    })
      .then((res) => {
        if (res.status === 200) return;
        else throw new Error();
      })
      .then((data) => {
        setRefresh(!refresh);
        alert.push("Disabled", `${user_id} has been disabled`);
      })
      .catch((e) => {
        console.log(e);
        alert.push("Error", "An error occurred");
      });
  };
  const EnableUser = (user_id) => {
    fetch(base_url + "admin/users/enable", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      body: `employee_id=${user_id}`,
      credentials: "include",
    })
      .then((res) => {
        if (res.status === 200) return;
        else throw new Error();
      })
      .then((data) => {
        setRefresh(!refresh);
        alert.push("Enabled", `${user_id} has been enabled`);
      })
      .catch((e) => {
        console.log(e);
        alert.push("Error", "An error occurred");
      });
  };
  useEffect(() => {
    RequestData(filter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, openModal, refresh]);
  useEffect(() => {
    handleChange(1, "page");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [maxPages]);
  const columns = useMemo(
    () => [
      // eslint-disable-next-line react-hooks/exhaustive-deps
      {
        Header: "User ID",
        accessor: "user_id",
        disableSortBy: true,
        Cell: ({ row, value }) => {
          return <span>{value}</span>;
        },
      },
      {
        Header: "Name",
        accessor: "full_name",
        disableSortBy: true,
        Cell: ({ row, value }) => {
          return <span>{value}</span>;
        },
      },
      {
        Header: "Email",
        accessor: "email",
        disableSortBy: true,
        Cell: ({ row, value }) => {
          return <span>{value}</span>;
        },
      },
      {
        Header: "User Type",
        accessor: "user_type",
        disableSortBy: true,
        Cell: ({ row, value }) => {
          return <span>{value}</span>;
        },
      },
      {
        Header: "Status",
        accessor: "status",
        disableSortBy: true,
        Cell: ({ row, value }) => {
          return <span>{value ? "Active" : "Disabled"}</span>;
        },
      },
      {
        Header: "Last Login",
        accessor: "last_login",
        disableSortBy: true,
        Cell: ({ row, value }) => {
          return <span>{formatDate(Number(value))}</span>;
        },
      },
      {
        Header: "Role",
        accessor: "role",
        disableSortBy: true,
        Cell: ({ row, value }) => {
          return <span>{value}</span>;
        },
      },
      {
        Header: "Creation Datee",
        accessor: "creation_date",
        disableSortBy: true,
        Cell: ({ row, value }) => {
          return <span>{formatDate(value)}</span>;
        },
      },
      {
        Header: "Created By",
        accessor: "created_by",
        disableSortBy: true,
        Cell: ({ row, value }) => {
          return <span>{value}</span>;
        },
      },
      {
        Header: "Delete",
        disableSortBy: true,
        Cell: ({ row, value }) => {
          console.log(row);
          return (
            <div className={styles.flexbox}>
              {/* <div className={styles.edit_button}/> */}
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  DeleteUser(row.values.user_id);
                }}
                className={styles.delete_button}
              />
              {/* <div className={styles.green_underline}>Reset password</div> */}
            </div>
          );
        },
      },
      {
        Header: "Disable",
        disableSortBy: true,
        Cell: ({ row, value }) => {
          console.log(row);
          return (
            <span
              className={styles.green_underline}
              onClick={(e) => {
                e.stopPropagation();
                if (row.values.status) DisableUser(row.values.user_id);
                else EnableUser(row.values.user_id);
              }}
            >
              {row.values.status ? "Disable" : "Enable"}
            </span>
          );
        },
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
    ],
    []
  );
  const handleChange = (value, field) => {
    console.log(`${value},${field}`);
    setFilter({ ...filter, [field]: value });
  };

  return (
    <div className={styles.main_box}>
      <h1>Users</h1>
      {/* <h2 className={styles.sub_title}>What are assets</h2> */}
      <div className={styles.table_div}>
        <TableFilter
          filter={filter}
          setFilter={setFilter}
          handleChange={handleChange}
          DownloadCSV={DownloadCSV}
          setOpenModal={setOpenModal}
        />
        <UsersTable
          columns={columns}
          data={data}
          filter={filter}
          setFilter={setFilter}
          handleChange={handleChange}
        />
        <TableFooter
          filter={filter}
          setFilter={setFilter}
          maxPages={maxPages}
          handleChange={handleChange}
        />
        {openModal ? <NewUser OnClose={() => setOpenModal(false)} /> : null}
      </div>
    </div>
  );
}

export default Users;
